import { ArrowLeft, FileType2, Globe } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Badge } from '@/components/ui-kit/badge';
import { Button } from '@/components/ui-kit/button';
import { useDocxBuilder } from './context';
import { DocxBuilderStepper } from './stepper';

export function DocxBuilderHeader() {
  const { orgSlug, title, available, templateSlug } = useDocxBuilder();
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-3 h-14 shrink-0 border-b border-border bg-[hsl(var(--bg))] px-4">
      <div className="flex items-center gap-2 flex-1 min-w-0">
        <Button
          variant="ghost"
          size="icon"
          className="shrink-0"
          onClick={() => navigate(`/org/${orgSlug}/templates`)}
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>

        <div className="h-8 w-8 rounded-lg bg-selise-blue/10 flex items-center justify-center shrink-0">
          <FileType2 className="h-4 w-4 text-selise-blue" />
        </div>

        <div className="flex items-start gap-2 min-w-0">
          <div className="min-w-0">
            <h1 className="text-base font-semibold text-[hsl(var(--fg))] truncate">{title}</h1>
            <p className="text-xs text-globe-grey truncate">{templateSlug}</p>
          </div>

          {available ? (
            <Badge variant="secondary" className="gap-1 shrink-0">
              <Globe className="h-3 w-3" />
              Published
            </Badge>
          ) : (
            <Badge variant="outline" className="shrink-0">
              Draft
            </Badge>
          )}
        </div>
      </div>

      <div className="h-4 w-px bg-border shrink-0 mx-1 hidden md:block" />

      <div className="shrink-0 hidden md:block">
        <DocxBuilderStepper />
      </div>
    </div>
  );
}
